import { TranslatorService } from '@services/translator/translator.service';
import { Component, OnInit, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-label-error',
  templateUrl: './label-error.component.html',
})
export class LabelErrorComponent implements OnInit{

  @Input() control: AbstractControl;
  @Input() messages;
  @Input() customMessage: string;
  requirefField: string 
  minLengthSchedule:string
  constructor(private translatrService : TranslatorService) { }

  ngOnInit(): void {
  
   this.translatrService.getMessage('Campo obrigatório').subscribe(val=>{
      this.requirefField=val
   })
   this.translateMessages()
  }
  translateMessages(){
    this.translatrService.getMessage('O tamanho mínimo de caracteres é').subscribe(val=>{
      this.minLengthSchedule=val
   })
  }
  // TODO: i18n
  get pattern() {
    if (this.messages && this.messages.pattern) {
      return this.messages.pattern;
    } else {
      return `Utilize o padrão ${this.control.errors.pattern.requiredPattern}`;
    }
  }

  // TODO: i18n
  get rules() {
    if (this.messages.rules) {
      return this.messages.rules;
    } else {
      return 'O valor digitado é inválido';
    }
  }
}
